import { MaterialDesignContent } from 'notistack';
import { ComponentProps, forwardRef } from 'react';

import styles from './SnackbarContent.module.scss';

export const SnackbarContent = forwardRef<
  HTMLDivElement,
  ComponentProps<typeof MaterialDesignContent>
>((props, ref) => <MaterialDesignContent {...props} ref={ref} className={styles.snackbar} />);
